export const RolesConstants = {
  CREATOR: "SCORING_APPEAL_CREATOR",
  EDITOR: "SCORING_APPEAL_EDITOR",
  VIEWER: "SCORING_APPEAL_VIEWER",
  COMMENTER: "SCORING_APPEAL_COMMENTER",
  APPROVER: "SCORING_APPEAL_APPROVER"
};
